import React from "react";
import { useTranslation } from "react-i18next";
import PinDropTwoToneIcon from "@mui/icons-material/PinDropTwoTone";
import SearchOutlinedComponent from "components/search/SearchOutlined.component";
import {
  Autocomplete,

  Grid,
  IconButton,
  Popper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import _ from "lodash";
import Card from "components/common/card/Card.component";
import CachedIcon from "@mui/icons-material/Cached";

const SelectZoneAndSearchComponent = ({
  listClusters = [],
  handleChangeZone = () => { },
  zoneSelected,
  handleSearch = () => { },
  loading,
  onRefresh = () => { },
  valueSearch,
}) => {
  const { t } = useTranslation();
  const theme = useTheme()
  return (
    <Card>
      <Grid container alignItems="center" spacing={2}>
        <Grid
          item
          xs={12}
          sm={2.5}
          md={3}
          lg={2.5}
          display="flex"
          alignItems="center"
        >
          <Typography variant="h3" sx={{ fontSize: 18, mr: 2 }}>
            {t("data-relating-to-the-area")}
          </Typography>
          <PinDropTwoToneIcon style={{ width: 19, height: 19 }} />
        </Grid>
        <Grid item xs={10} sm={4.45} md={4.2} lg={4.45}>
          <Autocomplete
            multiple
            noOptionsText={t('No Options')}
            options={listClusters}
            value={zoneSelected}
            loading={loading}
            name="zone"
            onChange={(e, value) => handleChangeZone(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                name="zone"
                label={
                  _.isEmpty(zoneSelected)
                    ? t("all-zones")
                    : t("select-one-or-more zones")
                }
              />
            )}
            size="small"
            PopperComponent={({ style, ...props }) => (
              <Popper
                {...props}
                style={{ ...style, zIndex: 20 }}
              />
            )}

            sx={{
              zIndex: 10,
              '& .MuiAutocomplete-popper': {
                backgroundColor: 'red',
                zIndex: 10
              }
            }}
          />
        </Grid>
        <Grid item xs={10} sm={4.45} md={4.2} lg={4.45}>
          <SearchOutlinedComponent
            label={t("Search")}
            handleSearch={handleSearch}
            valueSearch={valueSearch}
          />
        </Grid>
        <Grid
          item
          xs={2}
          sm={0.6}
          md={0.6}
          lg={0.6}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <IconButton
            onClick={() => onRefresh()}
            sx={{
              backgroundColor: theme.palette.primary.main,
              borderRadius: 2,
            }}
          >
            <CachedIcon
              sx={{
                color: "white",
                "&:hover": { color: theme.palette.primary.main },
              }}
              fontSize="small"
            />
          </IconButton>
        </Grid>

      </Grid>
    </Card>

  );
};

export default SelectZoneAndSearchComponent;
